import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

// Tool add/edit forms are full pages only under the Partner dashboard; other mounts of the same
// tool components keep their popups.
export const PARTNER_TOOLS_BASE = "/partner/tools";
export const CASHBOOK_HOME = `${PARTNER_TOOLS_BASE}/cashbook`;
export const KHATABOOK_HOME = `${PARTNER_TOOLS_BASE}/khatabook`;
export const PROJECTS_HOME = `${PARTNER_TOOLS_BASE}/projects`;

export const cashbookListUrl = (bookId) => (bookId ? `${CASHBOOK_HOME}?book=${bookId}` : CASHBOOK_HOME);

/** Same token lookup the tool pages use. */
export const useToolsToken = () => {
  const authState = useSelector((state) => state.auth);
  const loggedInUser = authState?.user ?? authState;
  return loggedInUser?.refreshToken || authState?.refreshToken || loggedInUser?.token || authState?.token;
};

/** True when the tool is mounted under /partner/tools, where add/edit open as full pages. */
export const useFullPageForms = () => useLocation().pathname.startsWith(`${PARTNER_TOOLS_BASE}/`);

export const khatabookListUrl = (bookId, customerId) => {
  if (!bookId) return KHATABOOK_HOME;
  return `${KHATABOOK_HOME}?book=${bookId}${customerId ? `&customer=${customerId}` : ""}`;
};

export const projectUrl = (projectId, tab) => {
  if (!projectId) return PROJECTS_HOME;
  return `${PROJECTS_HOME}?project=${projectId}${tab ? `&tab=${tab}` : ""}`;
};
